import React, { useState, useMemo, useCallback, memo } from "react";
import Popover from "antd/lib/popover";
import Popovercard from "./popover";
import { MenuItem, WrapperPopover } from "./styled.components";
import { useNavigate } from "react-router-dom";
const Menu = memo(({ title, url, items }) => {
  const naviagte = useNavigate();

  const [active, setActive] = useState(false);

  const handleVisibleChange = useCallback((visible) => {
    setActive(visible);
  }, []);

  const content = useMemo(() => {
    if (items)
      return (
        <WrapperPopover>
          {(items ?? []).map((props) => {
            return <Popovercard key={props.id} {...props} />;
          })}
        </WrapperPopover>
      );
    return null;
  }, [items]);

  if (items) {
    return (
      <Popover
        placement="bottom"
        content={content}
        trigger="click"
        overlayClassName="menu-popover"
        onVisibleChange={handleVisibleChange}
      >
        <MenuItem active={active}>{title}</MenuItem>
      </Popover>
    );
  }

  return <MenuItem onClick={() => naviagte(`${url}`)}>{title}</MenuItem>;
});

export default Menu;
